import React from "react";
import MaterialTable from "material-table";
import Cookies from "universal-cookie";
import { config } from "../services/config";



// COOKIE
const cookies = new Cookies();

const token = cookies.get("browser_ID");



const AchievementPage = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard">
          <MaterialTable
            columns={[
              { title: "Programme", field: "programme", editable: 'never' },
              { title: "Description", field: "desc"},
              { title: "Total", field: "total" }
            ]}
            data={query =>
              new Promise((resolve, reject) => {
                fetch(config.achievements, {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  }
                })
                  .then(response => response.json())
                  .then(result => {
                    if (result.success) {
                      resolve({
                        data: result.data,
                      });
                    } else {
                      reject(console.log("error"));
                    }
                  });
              })
            }
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  fetch(config.achievementEdit + oldData.id, {
                    method: "PUT",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                      total: newData.total,
                      desc: newData.desc
                    })
                  })
                    .then(response => response.json())
                    .then(result => {
                      if (result.success) {
                        resolve();
                      } else {
                        reject(console.log("error"));
                      }
                    });
                })
            }}
            title="Achievements"
            options={{
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
              search: false,
              paging: false
            }}
          />
      </div>
    </div>
  );
};

export default AchievementPage;
